@if (vm$ | async; as vm) {
	<bci-wk-modal
		[closeOnEsc]="!vm.loaderButton"
		[closeOnX]="!vm.loaderButton"
		[closeOnOverlay]="!vm.loaderButton"
	>
		<bci-wk-modal-title bciWkTypeH1000 class="title-modal">
			Edita tu número de teléfono
		</bci-wk-modal-title>
		<form [formGroup]="formInputPhone">
			<bci-wk-input-phone
				formControlName="phoneNumber"
				[placeholder]="'9999999'"
				[label]="'Teléfono'"
				[oneAreaCode]="'9'"
				class="input"
				appValidatePhone
			>
				<bci-form-msg *ngIf="phoneControl.invalid && phoneControl.touched">
					Ingresa un teléfono válido
				</bci-form-msg>
			</bci-wk-input-phone>
		</form>
		<bci-wk-modal-actions class="wrap-buttton">
			<button
				bciWkButtonPrimary
				[isLoading]="vm.loaderButton"
				[disabled]="formInputPhone.invalid"
				(click)="onUpdatePhone(vm.customer?.companyRut!, vm.loaderButton)"
			>
				Actualizar
			</button>
		</bci-wk-modal-actions>
	</bci-wk-modal>
}
